const CONSTANTS = {

	// for sing -in
	LOGIN_REQUEST: 'LOGIN_REQUEST',
	LOGIN_SUCCESS: 'LOGIN_SUCCESS',
	LOGIN_FAILURE: 'LOGIN_FAILURE',

	// for sing-up
	SINGUP_REQUEST: 'SINGUP_REQUEST',
	SINGUP_SUCCESS: 'SINGUP_SUCCESS',
	SINGUP_FAILURE: 'SINGUP_FAILURE',


	// user details request 
	USER_DETAILS_REQUEST: 'USER_DETAILS_REQUEST',
	USER_DETAILS_SUCCESS: 'USER_DETAILS_SUCCESS',
	USER_DETAILS_FAILURE: 'USER_DETAILS_FAILURE',

	// sms and email request 
	SMS_EMAIL_REQUEST: 'SMS_EMAIL_REQUEST',
	SMS_EMAIL_SUCCESS: 'SMS_EMAIL_SUCCESS',
	SMS_EMAIL_FAILURE: 'SMS_EMAIL_FAILURE',

	// download ticket request 
	DOWNLOAD_TICKET_REQUEST: 'DOWNLOAD_TICKET_REQUEST',
	DOWNLOAD_TICKET_SUCCESS: 'DOWNLOAD_TICKET_SUCCESS',
	DOWNLOAD_TICKET_FAILURE: 'DOWNLOAD_TICKET_FAILURE',

	// get facity
	GET_FACILITY_RATE_REQUEST: 'GET_FACILITY_RATE_REQUEST',
	GET_FACILITY_RATE_SUCCESS: 'GET_FACILITY_RATE_SUCCESS',
	GET_FACILITY_RATE_FAILURE: 'GET_FACILITY_RATE_FAILURE',

	// added payment card api contants
	POST_CARD_DETAILS_REQUEST: 'POST_CARD_DETAILS_REQUEST',
	POST_CARD_DETAILS_SUCCESS: 'POST_CARD_DETAILS_SUCCESS',
	POST_CARD_DETAILS_FAILURE: 'POST_CARD_DETAILS_FAILURE',

	EXTEND_CARD_DETAILS_REQUEST: 'EXTEND_CARD_DETAILS_REQUEST',
	EXTEND_CARD_DETAILS_SUCCESS: 'EXTEND_CARD_DETAILS_SUCCESS',
	EXTEND_CARD_DETAILS_FAILURE: 'EXTEND_CARD_DETAILS_FAILURE',

	EXTEND_CARD_HOUR_REQUEST: 'EXTEND_CARD_HOUR_REQUEST',
	EXTEND_CARD_HOUR_SUCCESS: 'EXTEND_CARD_HOUR_SUCCESS',
	EXTEND_CARD_HOUR_FAILURE: 'EXTEND_CARD_HOUR_FAILURE',

	// get ticket details
	GET_TICKET_DETAILS_REQUEST: 'GET_TICKET_DETAILS_REQUEST',
	GET_TICKET_DETAILS_SUCCESS: 'GET_TICKET_DETAILS_SUCCESS',
	GET_TICKET_DETAILS_FAILURE: 'GET_TICKET_DETAILS_FAILURE',
	GET_LOADER_FALSE: 'GET_LOADER_FALSE',
	// payment Card Post
	POST_CARD_PAYMENT_REQUEST: 'POST_CARD_PAYMENT_REQUEST',
	POST_CARD_PAYMENT_SUCCESS: 'POST_CARD_PAYMENT_SUCCESS',
	POST_CARD_PAYMENT_FAILURE: 'POST_CARD_PAYMENT_FAILURE',


	// End Current Parking
	END_PARKING_REQUEST: 'END_PARKING_REQUEST',
	END_PARKING_SUCCESS: 'END_PARKING_SUCCESS',
	END_PARKING_FAILURE: 'END_PARKING_FAILURE',

	// promoCode request 
	PROMOCODE_REQUEST: 'PROMOCODE_REQUEST',
	PROMOCODE_SUCCESS: 'PROMOCODE_SUCCESS',
	PROMOCODE_FAILURE: 'PROMOCODE_FAILURE',

	// Reset Password
	POST_RESET_PASSWORD_REQUEST: 'POST_RESET_PASSWORD_REQUEST',
	POST_RESET_PASSWORD_SUCCESS: 'POST_RESET_PASSWORD_SUCCESS',
	POST_RESET_PASSWORD_FAILURE: 'POST_RESET_PASSWORD_FAILURE',

	//  update user profile 
	UPDATE_USER_PROFILE_REQUEST: 'UPDATE_USER_PROFILE_REQUEST',
	UPDATE_USER_PROFILE_SUCCESS: 'UPDATE_USER_PROFILE_SUCCESS',
	UPDATE_USER_PROFILE_FAILURE: 'UPDATE_USER_PROFILE_FAILURE',

	//  get user profile 
	GET_USER_PROFILE_REQUEST: 'GET_USER_PROFILE_REQUEST',
	GET_USER_PROFILE_SUCCESS: 'GET_USER_PROFILE_SUCCESS',
	GET_USER_PROFILE_FAILURE: 'GET_USER_PROFILE_FAILURE',


	// promoCode request 
	PROMOCODE_TICKET_REQUEST: 'PROMOCODE_TICKET_REQUEST',
	PROMOCODE_TICKET_SUCCESS: 'PROMOCODE_TICKET_SUCCESS',
	PROMOCODE_TICKET_FAILURE: 'PROMOCODE_TICKET_FAILURE',

	// promoCode request 
	EXTEND_TICKET_LIST_REQUEST: 'EXTEND_TICKET_LIST_REQUEST',
	EXTEND_TICKET_LIST_SUCCESS: 'EXTEND_TICKET_LIST_SUCCESS',
	EXTEND_TICKET_LIST_FAILURE: 'EXTEND_TICKET_LIST_FAILURE',

	// send email for forgot password
	SEND_EMAIL_RESET_PASSWORD_REQUEST: 'SEND_EMAIL_RESET_PASSWORD_REQUEST',
	SEND_EMAIL_RESET_PASSWORD_SUCCESS: 'SEND_EMAIL_RESET_PASSWORD_SUCCESS',
	SEND_EMAIL_RESET_PASSWORD_FAILURE: 'SEND_EMAIL_RESET_PASSWORD_FAILURE',

	GET_VEHILCE_LIST_REQUEST: 'GET_VEHILCE_LIST_REQUEST',
	GET_VEHILCE_LIST_SUCCESS: 'GET_VEHILCE_LIST_SUCCESS',
	GET_VEHILCE_LIST_FAILURE: 'GET_VEHILCE_LIST_FAILURE',

	ADD_VEHILCE_REQUEST: 'ADD_VEHILCE_REQUEST',
	ADD_VEHILCE_SUCCESS: 'ADD_VEHILCE_SUCCESS',
	ADD_VEHILCE_FAILURE: 'ADD_VEHILCE_FAILURE',

	// CARD ADD DELETE LIST

	GET_CARD_LIST_REQUEST: 'GET_CARD_LIST_REQUEST',
	GET_CARD_LIST_SUCCESS: 'GET_CARD_LIST_SUCCESS',
	GET_CARD_LIST_FAILURE: 'GET_CARD_LIST_FAILURE',

	ADD_CARD_REQUEST: 'ADD_CARD_REQUEST',
	ADD_CARD_SUCCESS: 'ADD_CARD_SUCCESS',
	ADD_CARD_FAILURE: 'ADD_CARD_FAILURE',

	DELETE_CARD_REQUEST: 'DELETE_CARD_REQUEST',
	DELETE_CARD_SUCCESS: 'DELETE_CARD_SUCCESS',
	DELETE_CARD_FAILURE: 'DELETE_CARD_FAILURE',

	CARD_UPDATE_REQUEST: 'CARD_UPDATE_REQUEST',
	CARD_UPDATE_SUCCESS: 'CARD_UPDATE_SUCCESS',
	CARD_UPDATE_FAILED: 'CARD_UPDATE_FAILED',

	// CARD ADD DELETE LIST

	// RECEIPTS

	GET_RECEIPTS_REQUEST: 'GET_RECEIPTS_REQUEST',
	GET_RECEIPTS_SUCCESS: 'GET_RECEIPTS_SUCCESS',
	GET_RECEIPTS_FAILURE: 'GET_RECEIPTS_FAILURE',

	// RECEIPTS
	DELETE_VEHILCE_REQUEST: 'DELETE_VEHILCE_REQUEST',
	DELETE_VEHILCE_SUCCESS: 'DELETE_VEHILCE_SUCCESS',
	DELETE_VEHILCE_FAILURE: 'DELETE_VEHILCE_FAILURE',

	EDIT_VEHILCE_REQUEST: 'EDIT_VEHILCE_REQUEST',
	EDIT_VEHILCE_SUCCESS: 'EDIT_VEHILCE_SUCCESS',
	EDIT_VEHILCE_FAILURE: 'EDIT_VEHILCE_FAILURE',

	// HANDLE EVENT LOGS

	ADD_EVENT_LOG_REQUEST: 'ADD_EVENT_LOG_REQUEST',
	ADD_EVENT_LOG_SUCCESS: 'ADD_EVENT_LOG_SUCCESS',
	ADD_EVENT_LOG_FAILURE: 'ADD_EVENT_LOG_FAILURE',

	// HANDLE EVENT LOGS

	// CHECK ACTIVE CHECKIN

	CHECK_ACTIVE_SESSION_REQUEST: 'CHECK_ACTIVE_SESSION_REQUEST',
	CHECK_ACTIVE_SESSION_SUCCESS: 'CHECK_ACTIVE_SESSION_SUCCESS',
	CHECK_ACTIVE_SESSION_FAILURE: 'CHECK_ACTIVE_SESSION_FAILURE',

	// CHECK ACTIVE CHECKIN

	// CHECK ACTIVE CHECKIN

	RESET_PASSWORD_REQUEST: 'RESET_PASSWORD_REQUEST',
	RESET_PASSWORD_SUCCESS: 'RESET_PASSWORD_SUCCESS',
	RESET_PASSWORD_FAILURE: 'RESET_PASSWORD_FAILURE',

	// CHECK ACTIVE CHECKIN

	// faclity on marker
	FACILITY_ON_MARKER_REQUEST: 'FACILITY_ON_MARKER_REQUEST',
	FACILITY_ON_MARKER_SUCCESS: 'FACILITY_ON_MARKER_SUCCESS',
	FACILITY_ON_MARKER_FAILURE: 'FACILITY_ON_MARKER_FAILURE',
	// faclity on marker end

	// Service Pages 

	GET_SERVICES_REQUEST: 'GET_SERVICES_REQUEST',
	GET_SERVICES_SUCCESS: 'GET_SERVICES_SUCCESS',
	GET_SERVICES_FAILURE: 'GET_SERVICES_FAILURE',


	// //TICKET DETAILS
	// GET_TICKET_DETAILS_REQUEST: 'GET_TICKET_DETAILS_REQUEST',
	// GET_TICKET_DETAILS_SUCCESS: 'GET_TICKET_DETAILS_SUCCESS',
	// GET_TICKET_DETAILS_FAILURE: 'GET_TICKET_DETAILS_FAILURE',

	// RATES BANDS
	GET_RATE_BANDS_REQUEST: 'GET_RATE_BANDS_REQUEST',
	GET_RATE_BANDS_SUCCESS: 'GET_RATE_BANDS_SUCCESS',
	GET_RATE_BANDS_FAILURE: 'GET_RATE_BANDS_FAILURE',

	// GET PARTNER DETAILS
	GET_PARTNER_DETAILS_BY_SLUG_REQUEST: 'GET_PARTNER_DETAILS_BY_SLUG_REQUEST',
	GET_PARTNER_DETAILS_BY_SLUG_SUCCESS: 'GET_PARTNER_DETAILS_BY_SLUG_SUCCESS',
	GET_PARTNER_DETAILS_BY_SLUG_FAILURE: 'GET_PARTNER_DETAILS_BY_SLUG_FAILURE',


	//get vehicle Model list
	GET_VEHICLE_MODEL_REQUEST: 'GET_VEHICLE_MODEL_REQUEST',
	GET_VEHICLE_MODEL_SUCCESS: 'GET_VEHICLE_MODEL_SUCCESS',
	GET_VEHICLE_MODEL_FAILURE: 'GET_VEHICLE_MODEL_FAILURE',

	// ticket validate constants
	TICKET_VALIDATE_REQUEST: 'TICKET_VALIDATE_REQUEST',
	TICKET_VALIDATE_SUCCESS: 'TICKET_VALIDATE_SUCCESS',
	TICKET_VALIDATE_FAILED: 'TICKET_VALIDATE_FAILED',


	// Reservation ID constants
	RESERVATION_ID_REQUEST: 'RESERVATION_ID_REQUEST',
	RESERVATION_ID_SUCCESS: 'RESERVATION_ID_SUCCESS',
	RESERVATION_ID_FAILED: 'RESERVATION_ID_FAILED',

	// Fetch Rate Details
	FETCH_RATE_DETAILS_REQUEST: 'FETCH_RATE_DETAILS_REQUEST',
	FETCH_RATE_DETAILS_SUCCESS: 'FETCH_RATE_DETAILS_SUCCESS',
	FETCH_RATE_DETAILS_FAILED: 'FETCH_RATE_DETAILS_FAILED',

	PROMO_MSGE_ENABLE: 'PROMO_MSGE_ENABLE',
	PROMO_MSGE_DISABLE: 'PROMO_MSGE_DISABLE',

	// UNEXPECTED ERROR LOG
	UNEXPECTED_ERROR: 'UNEXPECTED_ERROR',
	SALE_API_FAILURE: 'SALE_API_FAILURE',
	SALE_API_SUCCESS: 'SALE_API_SUCCESS',
	DATA_FROM_URL: 'DATA_FROM_URL',

	FACILITY_LOADED: 'FACILITY_LOADED',
	SET_ACTIVE_SESSION: 'SET_ACTIVE_SESSION',

	PASS_DOWNLOAD_REQUEST: 'PASS_DOWNLOAD_REQUEST',
	PASS_DOWNLOAD_SUCCESS: 'PASS_DOWNLOAD_SUCCESS',
	PASS_DOWNLOAD_FAILURE: 'PASS_DOWNLOAD_FAILURE',

	GET_START_DATEBY_LICENSE_REQUEST: 'GET_START_DATEBY_LICENSE_REQUEST',
	GET_START_DATEBY_LICENSE_SUCCESS: 'GET_START_DATEBY_LICENSE_SUCCESS',
	GET_START_DATEBY_LICENSE_FAILURE: 'GET_START_DATEBY_LICENSE_FAILURE',

	APPLE_PAY_SESSION_REQUEST: 'APPLE_PAY_SESSION_REQUEST',
	APPLE_PAY_SESSION_SUCCESS: 'APPLE_PAY_SESSION_SUCCESS',
	APPLE_PAY_SESSION_FAILURE: 'APPLE_PAY_SESSION_FAILURE',

	DATACAP_SALE_GPAY_REQUEST: 'DATACAP_SALE_GPAY_REQUEST',
	DATACAP_SALE_GPAY_SUCCESS: 'DATACAP_SALE_GPAY_SUCCESS',
	DATACAP_SALE_GPAY_FAILURE: 'DATACAP_SALE_GPAY_FAILURE',
	DATACAP_SALE_APL_REQUEST: 'DATACAP_SALE_APL_REQUEST',
	DATACAP_SALE_APL_SUCCESS: 'DATACAP_SALE_APL_SUCCESS',
	DATACAP_SALE_APL_FAILURE: 'DATACAP_SALE_APL_FAILURE',

	UPDATE_SELECTED_HOURS: 'UPDATE_SELECTED_HOURS',

	IS_WELCOME_POPUP: 'IS_WELCOME_POPUP'

}

export default CONSTANTS